import { config } from '@config';

/**
 * Single source of truth for the innovator technology TRL analysis chat
 * endpoint, mirroring the Mission Assessment AI endpoint constants.
 */
export const getTechnologyTrlAnalysisChatEndpoint = (technologyId: string): string =>
  `${config.api.baseUrl}/v1/innovator/technologies/${technologyId}/trl-analysis/chat`;
